export const normalizeCartSelection = (ids = []) => {
    if (!Array.isArray(ids)) return [];
    return [...new Set(ids.filter((id) => id !== undefined && id !== null && id !== ''))];
};

export const toggleCartSelection = (selectedIds = [], cartId) => {
    const next = normalizeCartSelection(selectedIds);
    if (next.includes(cartId)) {
        return next.filter((id) => id !== cartId);
    }
    return [...next, cartId];
};

export const isAllVisibleCartsSelected = (visibleCartIds = [], selectedIds = []) => {
    const normalizedSelected = normalizeCartSelection(selectedIds);
    if (visibleCartIds.length === 0) return false;
    return visibleCartIds.every((id) => normalizedSelected.includes(id));
};